// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fullscreen-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 5H5V9M9 19H5V15M15 5H19V9M15 19H19V15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fullscreen1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fullscreen-1',
    ref,
    icon: element,
  },
));

Fullscreen1Icon.displayName = 'Fullscreen1Icon';

export default Fullscreen1Icon;
